import { memo } from 'react';
import { StyleSheet } from 'react-native';

import { GradientDoubleArrow } from '@/assets/icons/GradientDoubleArrow';
import { Text } from '@/components/TextComponent';
import { GradientText } from '@/components/gradient-text/GradientText';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem, withOpacity } from '@/styles/styles';

import { GRADIENT_COLORS } from './config';

export const MultiplierTag = memo(
    ({ oldMultiplier, newMultiplier }: { oldMultiplier: number; newMultiplier: number }) => {
        return (
            //
            <Box position={'absolute'} top={-16} zIndex={1} width={'100%'} alignItems={'center'}>
                <Row
                    gap={'s2'}
                    alignItems={'center'}
                    backgroundColor={ds.colorToken.background.neutral.strong}
                    style={styles.container}
                    borderRadius={'r10'}
                >
                    <Text
                        testID={'race-to-place-old-multiplier'}
                        variant={'titleMedium'}
                        color={ds.colorToken.text.secondary}
                    >{`Was ${oldMultiplier}x`}</Text>
                    <GradientDoubleArrow />
                    <GradientText
                        testID={'race-to-place-new-multiplier'}
                        variant="titleMedium"
                        colors={GRADIENT_COLORS}
                        text={`Now ${newMultiplier}x`}
                        letterSpacing={0.2}
                        positions={[-0.2183, 0.3967, 1]}
                    />
                </Row>
            </Box>
        );
    }
);

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 9,
        paddingVertical: 3,
        borderWidth: 1,
        borderColor: ds.colorValue.border.subtle,
        shadowColor: withOpacity(designSystem.colors.neutralBlack, 0.24),
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.24,
        shadowRadius: 16,
        elevation: 8,
    },
});
